





















  import { Component, Vue } from 'nuxt-property-decorator'
  import { namespace } from 'vuex-class'
  import { BDropdown } from 'bootstrap-vue/src/components/dropdown'

  const cms = namespace('cms')

  @Component({
    components: {
      SidebarAccount: () => import('~/pages/account/SidebarAccount.vue'),
    },
  })
  export default class AccountDropdownComponent extends Vue {
    @cms.Getter accountDashboardStaticPage: any

    get accountLink() {
      return this.accountDashboardStaticPage
        ? { name: 'account-slug', params: { slug: 'dashboard' } }
        : this.localePath('account')
    }

    closeDropdown() {
      (this.$refs.navDropdown as BDropdown).hide()
    }
  }
